import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound({ title, message, backTo = -1 }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const displayTitle = title || t("notFound.title");
  const displayMessage = message || t("notFound.message");

  return (
    <div
      style={{
        padding: "3rem 1rem",
        textAlign: "center",
        maxWidth: "600px",
        margin: "0 auto",
        color: "#444",
        fontFamily: "Inter, sans-serif"
      }}
    >
      <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>{displayTitle}</h1>

      <p style={{ fontSize: "1rem", opacity: 0.8, marginBottom: "2rem" }}>
        {displayMessage}
      </p>

      <button
        onClick={() => navigate(backTo)}
        style={{
          padding: "0.75rem 1.5rem",
          backgroundColor: "black",
          color: "white",
          borderRadius: "6px",
          border: "none",
          cursor: "pointer",
          fontSize: "1rem"
        }}
      >
        {t("common.back")}
      </button>
    </div>
  );
}
